import { Injector } from '@angular/core';

export class DecoratorService {
  static injector: Injector;
}
